import axios from 'axios';

// Базовый URL: на проде работаем через Nginx proxy, поэтому по умолчанию пусто
const BASE_URL = process.env.REACT_APP_API_URL || '';

// Единый HTTP-клиент для админ-панели
const http = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' }
});

// === Авторизация: добавление Bearer к каждому запросу ===
http.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// === Обновление токена (singleton-очередь) ===
let isRefreshing = false;
let subscribers = [];

const subscribe = (cb) => subscribers.push(cb);
const publish = (token, error) => {
  subscribers.forEach((cb) => cb(token, error));
  subscribers = [];
};

const getRefreshToken = () => localStorage.getItem('refresh_token');
const saveAccessToken = (token) => {
  if (token) localStorage.setItem('access_token', token);
};
const clearAuth = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
};

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const original = error.config || {};

    if (status !== 401 || original._retry) {
      return Promise.reject(error);
    }

    original._retry = true;
    const refresh = getRefreshToken();
    if (!refresh) {
      clearAuth();
      window.location.replace('/login');
      return Promise.reject(error);
    }

    // Если уже идет процесс рефреша — подписываемся и ждём
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        subscribe((token, err) => {
          if (err || !token) return reject(err || new Error('refresh_failed'));
          original.headers = original.headers || {};
          original.headers['Authorization'] = `Bearer ${token}`;
          resolve(http(original));
        });
      });
    }

    // Инициируем рефреш
    try {
      isRefreshing = true;
      const resp = await axios.post('/api/accounts/token/refresh/', { refresh });
      const newToken = resp.data?.access;
      if (!newToken) throw new Error('no_access_token');
      saveAccessToken(newToken);
      http.defaults.headers['Authorization'] = `Bearer ${newToken}`;
      publish(newToken, null);
      original.headers = original.headers || {};
      original.headers['Authorization'] = `Bearer ${newToken}`;
      return http(original);
    } catch (e) {
      publish(null, e);
      clearAuth();
      window.location.replace('/login');
      return Promise.reject(e);
    } finally {
      isRefreshing = false;
    }
  }
);

export default http;


